import styles from "./Spinnerabsolute.module.css";

function Spinnerabsolute() {
  return (
    <div className={styles.overlay} style={{zIndex:9}}>
      <div className={styles.spinner}></div>
    </div>
  );
}

export default Spinnerabsolute;